import React, { useState, useEffect } from 'react';
import { Button } from '@design-system-coopeuch/web';
import imgTimer from '../../../assets/img/time.gif';

import BoxInformativo from './styles.js';

const AlertInformativo = ({ imagen, saldoDisponible, tarjetaEstado, tipoDePago }) => {
  

  const [state, setstate] = useState({
    titulo: '',
    parrafo: '',
    bold: '',
    fin: '',
    imagen: '',
    link: ''
  })


  const irCoopeuch = () =>{
     window.location.href = 'https://www.coopeuch.cl';
  }

  const backPage = () =>{
    irCoopeuch();
  }

  useEffect(
    () => {
      let timer = setTimeout(() => backPage(),11000);
      return () => {
        clearTimeout(timer);
      };
    },
    []
  );


  useEffect(() => {
    if (!saldoDisponible) {
      setstate({
        ...state,
        titulo: tipoDePago === "01"? 'El saldo de tu tarjeta es insuficiente' :'Tu saldo es insuficiente',
        parrafo: tipoDePago === "01"? '' : 'Por favor',
        bold: tipoDePago === "01"? '' : 'abona',
        fin: tipoDePago === "01"? '' : 'la cantidad necesaria en tu Cuenta Coopeuch para luego retomar tu compra.',
        link: tipoDePago === "01"? '' : <Button color="primary" variant="text" onClick={() => irCoopeuch()}>Ir a Coopeuch</Button>

      })
    } 
    if (!tarjetaEstado) {
      setstate({
        ...state,
        titulo: 'Tu Tarjeta se encuentra inactiva o bloqueada.',
        parrafo: 'Llámanos al ',
        bold: '600 200 1200.'
      })
    }
  }, [saldoDisponible, tarjetaEstado])

  const Info = () =>{
    return <section className="error-controlado">
    <hr />
    <div className="contenedor-informacion-error">
      <img src={imagen} alt="alert-informativo" />
      <hgroup>
        <p className="strong">{state.titulo}</p>
        <p className="contentido">{state.parrafo} <strong>{state.bold}</strong> {state.fin}</p>
        {state.link}
      </hgroup>
      <img className="timerimg" src={imgTimer} alt="alert-informativo" />
    </div>
  </section>
  } 


  const { titulo } = state;
  return (
    <BoxInformativo> 
          {titulo ? <Info /> : "" }
    </BoxInformativo>
  )
}

export default AlertInformativo;